/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Author = styled.div(
  () => css`
    width: clamp(200px, fit-content, 50%);

    * {
      color: #888888;
    }

    a {
      text-decoration: none;
      &:visited {
        color: #888888;
      }
    }
  `
)
